'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidScopeUrl = isValidScopeUrl;
exports.isUrlOfExperiment = isUrlOfExperiment;
var petriUrlMap = exports.petriUrlMap = {
  new: {
    conductAllInScope: '/_api/wix-laboratory-server/v1/laboratory/platform/conductAllInScope',
    conductExperiment: '/_api/wix-laboratory-server/v1/laboratory/platform/conductExperiment'
  },
  old: {
    conductAllInScope: '/_api/wix-laboratory-server/laboratory/conductAllInScope',
    conductExperiment: '/_api/wix-laboratory-server/laboratory/conductExperiment'
  }
};

var getAllInScopePath = exports.getAllInScopePath = function getAllInScopePath() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var useNewApi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var urlApi = useNewApi ? petriUrlMap.new.conductAllInScope + '?scope=' + scope : petriUrlMap.old.conductAllInScope + '?scope=' + scope;

  return urlApi;
};

function isValidScopeUrl(url, useNewApi) {
  return url.includes(useNewApi ? petriUrlMap.new.conductAllInScope : petriUrlMap.old.conductAllInScope);
}

var getExperimentPath = exports.getExperimentPath = function getExperimentPath() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var useNewApi = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var urlApi = useNewApi ? petriUrlMap.new.conductExperiment + '?key=' + key + '&fallbackValue=' + fallback : petriUrlMap.old.conductExperiment + '?key=' + key + '&fallback=' + fallback;

  return urlApi;
};

function isUrlOfExperiment(url, specName, useNewApi) {
  var pattern = '' + getExperimentPath(specName, '', useNewApi);
  return url.includes(pattern);
}